import classNames from 'classnames';
import * as React from 'react';

type Props = {
  children: React.ReactNode;
  className?: string;
};

export function Row(props: Props) {
  const { children, className } = props;

  return <div className={classNames('table-row', className)}>{children}</div>;
}
